// Reine Logik der Anzeige „Postfächer Ihrer Abteilungen" (Supportanfrage
// Klinger & Kollegen, 01.10.2026) – ohne Vue, damit sie mit Vitest prüfbar ist.

/** Ebene, von der das wirksame Postfach stammt; leer = keines gepflegt. */
export type MailboxSource = 'department' | 'location' | 'company' | ''

export interface DepartmentMailbox {
  idDepartment: number
  department: string
  location: string
  company: string
  /** Wirksame Adresse; leer, wenn auf keiner Ebene ein Postfach gepflegt ist. */
  email: string
  source: MailboxSource
}

const SOURCE_LABELS: Record<MailboxSource, string> = {
  'department': 'eigenes Postfach der Abteilung',
  'location': 'vom Standort übernommen',
  'company': 'vom Unternehmen übernommen',
  '': 'kein Postfach gepflegt',
}

export function mailboxSourceLabel (source: MailboxSource): string {
  return SOURCE_LABELS[source] ?? SOURCE_LABELS['']
}

/** „Abteilung · Standort" – fehlende Teile entfallen. */
export function mailboxPlace (mailbox: Pick<DepartmentMailbox, 'department' | 'location'>): string {
  return [mailbox.department, mailbox.location].filter(Boolean).join(' · ')
}

/** Übernimmt die Antwort des Backends; unbekannte Herkunft zählt als keine. */
export function normalizeMailboxes (raw: unknown): DepartmentMailbox[] {
  if (!Array.isArray(raw)) {
    return []
  }
  return raw.map(row => ({
    idDepartment: Number(row?.idDepartment) || 0,
    department: String(row?.department ?? ''),
    location: String(row?.location ?? ''),
    company: String(row?.company ?? ''),
    email: String(row?.email ?? ''),
    source: row?.source in SOURCE_LABELS ? row.source as MailboxSource : '',
  }))
}
